export const CLIENT_PRIORITY_LEVEL = [
  {
    value: 'HIGH',
    label: 'High',
  },
  {
    value: 'STANDARD',
    label: 'Standard',
  },
  {
    value: 'LOW',
    label: 'Low',
  },
];
